/**
 * @desc 明细
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.ApiInfoAggregateDto>;
export function request(params: API.appCenter.api.info.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/api/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
